import React, { useState, useEffect } from 'react';
import inspectionStorage from '../services/inspectionStorage';

// 🔥 Articles RVRAT - Installations électriques (EL) - IDENTIQUES à rvratRegulatoryPoints.js
const ARTICLES_INSTALLATIONS = [
  // Généralités
  { id: "EL1", article: "EL1", text: "Objectifs" },
  { id: "EL2", article: "EL2", text: "Documents à fournir" },
  
  // EL4 - Règles Générales
  { id: "EL4_1", article: "EL4 §1", text: "Les installations électriques sont conformes au décret n° 88-1056 du 14 novembre 1988 modifié pris pour l'exécution des dispositions du code du travail en ce qui concerne la protection des travailleurs" },
  { id: "EL4_1_foudre", article: "EL4 §1", text: "Protection contre la foudre" },
  { id: "EL4_2", article: "EL4 §2", text: "Canalisations étrangères à l'établissement" },
  { id: "EL4_3", article: "EL4 §3", text: "Installation desservant les locaux et dégagements accessibles au public" },
  { id: "EL4_4", article: "EL4 §4", text: "Conditions de poursuite de l'exploitation : a) Soit existence d'une source de remplacement en état de fonctionnement, alimentant l'éclairage de remplacement, les chargeurs des sources centralisées et les BAES. b) Soit éclairage naturel suffisant, respectant la sécurité du public" },
  { id: "EL4_4_sommeil", article: "EL4 §4", text: "Conditions particulières de locaux à sommeil ne disposant pas d'une source de remplacement" },
  { id: "EL4_5", article: "EL4 §5", text: "Tension dans les locaux et dégagements accessibles au public" },
  { id: "EL4_6", article: "EL4 §6", text: "Installations électriques des locaux à risques particuliers établies dans les conditions requises par la norme NFC15-100 pour les locaux présentant des risques d'incendie (BE2)" },
  
  // Règles d'installation
  { id: "EL5", article: "EL5", text: "Locaux de service électrique : • Identifiés et Réservés aux personnes qualifiées • Existence de moyens d'extinction adapté • Éclairage de sécurité fixe et mobile (BAPI)" },
  { id: "EL6", article: "EL6", text: "Matériels Haute Tension ou contenant des diélectriques susceptibles d'émettre de la vapeur" },
  { id: "EL7", article: "EL7", text: "Implantation des Groupes Électrogènes" },
  { id: "EL8", article: "EL8", text: "Batteries d'accumulateurs et matériels associés (chargeurs, onduleurs)" },
  
  // EL9 - Tableaux normaux
  { id: "EL9_local_service", article: "EL9", text: "Tableaux normaux : Implantation dans local de service électrique" },
  { id: "EL9_local_non_public", article: "EL9", text: "Tableaux normaux : Implantation dans local ou dégagement non accessible au public" },
  { id: "EL9_escaliers", article: "EL9", text: "Tableaux normaux : Absence de tableaux normaux dans les escaliers protégés" },
  { id: "EL9_100kva", article: "EL9", text: "Tableaux normaux : Implantation de tableaux normaux de puissance au plus égale à 100 kVA dans local ou dégagement accessible au public" },
  { id: "EL9_plus_100kva", article: "EL9", text: "Tableaux normaux : Implantation de tableaux normaux de puissance supérieure à 100 kVA dans local ou dégagement accessible au public" },
  
  // EL10 - Canalisations
  { id: "EL10_1", article: "EL10 §1", text: "Canalisation des installations normales remplacement : Canalisations fixes" },
  { id: "EL10_2", article: "EL10 §2", text: "Câbles ou conducteurs de catégorie C2" },
  { id: "EL10_3", article: "EL10 §3", text: "Conduits et les profilés utilisés pour le cheminement de câbles du type non propagateur de flamme" },
  { id: "EL10_4", article: "EL10 §4", text: "Degré coupe-feu des parois maintenu lors des traversées par des canalisations électriques" },
  
  // EL11 - Appareillages et appareils d'utilisation
  { id: "EL11_1", article: "EL11 §1", text: "Mise hors tension générale non accessible au public et ne coupant pas les alimentations de sécurité" },
  { id: "EL11_2", article: "EL11 §2", text: "Dispositif de coupure d'urgence non accessible au public" },
  { id: "EL11_3", article: "EL11 §3", text: "Enseignes lumineuses et leur coupure d'urgence" },
  { id: "EL11_4", article: "EL11 §4", text: "Les manœuvres des dispositifs de commande et de protection situés à moins de 2,5m du sol, doivent être sous la dépendance d'une clé ou d'un outil" },
  { id: "EL11_5", article: "EL11 §5", text: "Mise en œuvre des tableaux et appareils d'utilisation de manière à éviter l'apparition d'une température élevée ou le risque d'incendie" },
  { id: "EL11_6", article: "EL11 §6", text: "Les tableaux et les appareils d'utilisation installés dans les dégagements respectent les dispositions de l'article CO 37" },
  { id: "EL11_7", article: "EL11 §7", text: "Emploi de fiches multiples interdits. Nombre de prises de courant suffisant afin de limiter l'emploi de socles mobiles" },
  
  // Installations de sécurité
  { id: "EL12_17", article: "EL 12 à EL17", text: "Installations de sécurité" },
  
  // Maintenance, exploitation, vérification
  { id: "EL18_19", article: "EL18 à EL19", text: "Maintenance, exploitation, vérification" },
  
  // Installations temporaires
  { id: "EL20_23", article: "EL20 à EL23", text: "Installations temporaires" }
];

// 🔥 Articles RVRAT - Éclairage (EC) - IDENTIQUES à rvratRegulatoryPoints.js
const ARTICLES_ECLAIRAGE = [
  // Généralités
  { id: "EC1", article: "EC1", text: "Objectifs" },
  { id: "EC2", article: "EC2", text: "Règles générales" },
  { id: "EC4", article: "EC4", text: "Documents à fournir" },
  { id: "EC5", article: "EC5", text: "Appareils d'éclairage" },
  
  // Éclairage Normal
  { id: "EC6_1", article: "EC6 §1", text: "Emplacement concernés par l'éclairage normal - Dispositions vis-à-vis de l'obligation pour les dégagements, de ne pas pouvoir être plongés dans l'obscurité totale à partir des dispositifs de commande accessibles au public ou aux personnes non autorisées" },
  { id: "EC6_2", article: "EC6 §2", text: "Schéma unifilaire général de l'éclairage normal" },
  { id: "EC6_3", article: "EC6 §3", text: "Gestion automatique d'éclairage" },
  { id: "EC6_4", article: "EC6 §4", text: "Locaux de plus de 50 personnes" },
  { id: "EC6_5", article: "EC6 §5", text: "Appareils d'éclairages fixes ou suspendus" },
  { id: "EC6_6", article: "EC6 §6", text: "Utilisation de lampes à décharge" },
  
  // Éclairage de Sécurité
  { id: "EC7", article: "EC7", text: "a) Éclairage de sécurité à l'état de veille pendant l'exploitation de l'établissement b) En cas de défaillance de l'éclairage normal/remplacement, maintien ou mise en service de l'éclairage de sécurité pendant 1h au minimum c) Nature de l'éclairage de sécurité" },
  
  // EC8 - Fonctions de l'éclairage de sécurité
  { id: "EC8_1_2", article: "EC8 §1.2", text: "Fonctions de l'éclairage de sécurité : Éclairage d'évacuation" },
  { id: "EC8_1_3", article: "EC8 §1.3", text: "Fonctions de l'éclairage de sécurité : Éclairage d'ambiance ou d'antipanique" },
  
  // EC9 - Éclairage d'évacuation
  { id: "EC9_1", article: "EC9 §1", text: "Éclairage d'évacuation : Éclairage des indications de balisage" },
  { id: "EC9_2", article: "EC9 §2", text: "Éclairage d'évacuation : Espacement des foyers luminaux dans les couloirs et dégagements" },
  { id: "EC9_3", article: "EC9 §3", text: "Éclairage d'évacuation : Flux lumineux de 45 lumens minimum" },
  
  // EC10 - Éclairage d'ambiance ou d'antipanique
  { id: "EC10_1", article: "EC10 §1", text: "Éclairage d'ambiance ou d'antipanique : Allumage sur disparition de l'éclairage normal-remplacement" },
  { id: "EC10_2", article: "EC10 §2", text: "Éclairage d'ambiance ou d'antipanique : Flux lumineux" },
  { id: "EC10_2_rapport", article: "EC10 §2", text: "Éclairage d'ambiance ou d'antipanique : Rapport entre la distance séparant deux foyers lumineux et la hauteur du local" },
  
  // EC11 - Source centralisée
  { id: "EC11", article: "EC11", text: "Conception de l'éclairage de sécurité à source centralisée constituée d'une batterie d'accumulateur" },
  
  // EC12 - Blocs autonomes
  { id: "EC12_1", article: "EC12 §1", text: "Conception de l'éclairage de sécurité par blocs autonomes : Conformité aux normes" },
  { id: "EC12_2", article: "EC12 §2", text: "Canalisations d'alimentation en catégorie C2" },
  { id: "EC12_3", article: "EC12 §3", text: "Alimentation des blocs" },
  { id: "EC12_4", article: "EC12 §4", text: "Types de bloc pour l'éclairage d'évacuation" },
  { id: "EC12_5", article: "EC12 §5", text: "Types de bloc pour l'éclairage d'ambiance" },
  { id: "EC12_6", article: "EC12 §6", text: "Mise à l'état de repos par un ou plusieurs dispositifs" },
  { id: "EC12_7", article: "EC12 §7", text: "Nombre de blocs d'évacuation dans les dégagements supérieurs à 15m" },
  { id: "EC12_8", article: "EC12 §8", text: "Nombre de blocs d'ambiance ou d'antipanique par local ou hall" },
  
  // Maintenance et vérifications
  { id: "EC13", article: "EC13", text: "Maintenance et entretien" },
  { id: "EC14", article: "EC14", text: "Exploitation" },
  { id: "EC15", article: "EC15", text: "Vérifications" }
];

const STATUS_OPTIONS = [
  { value: 'C', label: 'C', color: '#16a34a', bgColor: '#dcfce7' },
  { value: 'NC', label: 'NC', color: '#dc2626', bgColor: '#fee2e2' },
  { value: 'SO', label: 'SO', color: '#64748b', bgColor: '#f1f5f9' },
  { value: 'HM', label: 'HM', color: '#f59e0b', bgColor: '#fef3c7' },
  { value: 'PM', label: 'PM', color: '#3b82f6', bgColor: '#dbeafe' }
];

const styles = {
  container: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
    paddingBottom: '100px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '16px 20px',
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    color: 'white',
    position: 'sticky',
    top: 0,
    zIndex: 100
  },
  headerTitle: {
    fontSize: '18px',
    fontWeight: '700',
    margin: 0
  },
  backBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontWeight: '600',
    cursor: 'pointer'
  },
  saveBtn: {
    background: 'rgba(255,255,255,0.2)',
    border: 'none',
    color: 'white',
    padding: '8px 16px',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer'
  },
  badge: {
    margin: '16px 20px',
    padding: '12px 16px',
    background: 'linear-gradient(135deg, #ede9fe, #ddd6fe)',
    border: '2px solid #8b5cf6',
    borderRadius: '12px',
    color: '#5b21b6',
    fontWeight: '600',
    textAlign: 'center',
    fontSize: '13px'
  },
  legend: {
    margin: '0 20px 16px',
    padding: '12px 16px',
    background: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  legendTitle: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '10px'
  },
  legendItems: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px'
  },
  legendItem: {
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '12px',
    fontWeight: '600'
  },
  tabs: {
    display: 'flex',
    gap: '8px',
    padding: '0 20px',
    marginBottom: '16px'
  },
  tab: {
    flex: 1,
    padding: '12px 16px',
    border: 'none',
    borderRadius: '12px',
    fontWeight: '600',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: '#e2e8f0',
    color: '#64748b'
  },
  tabActive: {
    background: 'linear-gradient(135deg, #8b5cf6, #7c3aed)',
    color: 'white',
    boxShadow: '0 4px 12px rgba(139, 92, 246, 0.3)'
  },
  content: {
    padding: '0 20px'
  },
  articleCard: {
    background: 'white',
    borderRadius: '12px',
    padding: '16px',
    marginBottom: '12px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
  },
  articleHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '12px'
  },
  articleCode: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#8b5cf6',
    background: '#ede9fe',
    padding: '4px 10px',
    borderRadius: '6px'
  },
  articleText: {
    fontSize: '14px',
    color: '#334155',
    lineHeight: '1.4',
    flex: 1,
    marginLeft: '12px'
  },
  statusButtons: {
    display: 'flex',
    gap: '6px',
    marginBottom: '12px'
  },
  statusBtn: {
    flex: 1,
    padding: '10px 8px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    fontWeight: '700',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s',
    background: 'white',
    color: '#64748b'
  },
  obsInput: {
    width: '100%',
    padding: '10px 12px',
    fontSize: '14px',
    border: '2px solid #e2e8f0',
    borderRadius: '8px',
    background: '#f8fafc',
    color: '#334155',
    boxSizing: 'border-box'
  },
  saveSection: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    padding: '16px 20px',
    background: 'white',
    boxShadow: '0 -4px 16px rgba(0,0,0,0.1)'
  },
  saveButton: {
    width: '100%',
    padding: '16px',
    background: 'linear-gradient(135deg, #10b981, #059669)',
    border: 'none',
    borderRadius: '12px',
    color: 'white',
    fontSize: '16px',
    fontWeight: '700',
    cursor: 'pointer'
  },
  loading: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: '#f8fafc'
  }
};

function Etape20AvisConformiteRVRATMobile({ mission, onBack, onSave }) {
  const [data, setData] = useState({
    installations_electriques: {},
    eclairage: {}
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [activeTab, setActiveTab] = useState('installations');

  useEffect(() => {
    loadData();
  }, [mission.id]);

  const loadData = async () => {
    setLoading(true);
    try {
      const savedData = await inspectionStorage.getStep(mission.id, 'etape_20_avis_conformite_rvrat');
      if (savedData) {
        setData(savedData);
      }
    } catch (error) {
      console.error('❌ Erreur chargement:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = (section, articleId, status) => {
    setData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [articleId]: {
          ...prev[section]?.[articleId],
          status
        }
      }
    }));
  };

  const handleObsChange = (section, articleId, obs) => {
    setData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [articleId]: {
          ...prev[section]?.[articleId],
          obs
        }
      }
    }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await inspectionStorage.saveStep(mission.id, 'etape_20_avis_conformite_rvrat', data);
      console.log('✅ Étape 20 sauvegardée');
      if (onSave) onSave(data);
      onBack();
    } catch (error) {
      console.error('❌ Erreur sauvegarde:', error);
      alert('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const renderArticle = (article, section) => {
    const articleData = data[section]?.[article.id] || {};
    const currentStatus = articleData.status || '';

    return (
      <div key={article.id} style={styles.articleCard}>
        <div style={styles.articleHeader}>
          <span style={styles.articleCode}>{article.article}</span>
          <span style={styles.articleText}>{article.text}</span>
        </div>

        <div style={styles.statusButtons}>
          {STATUS_OPTIONS.map(opt => (
            <button
              key={opt.value}
              style={{
                ...styles.statusBtn,
                ...(currentStatus === opt.value ? {
                  background: opt.bgColor,
                  borderColor: opt.color,
                  color: opt.color
                } : {})
              }}
              onClick={() => handleStatusChange(section, article.id, opt.value)}
            >
              {opt.label}
            </button>
          ))}
        </div>

        <input
          type="text"
          style={styles.obsInput}
          value={articleData.obs || ''}
          onChange={(e) => handleObsChange(section, article.id, e.target.value)}
          placeholder="N° observation (ex: 1, 2, 3...)"
        />
      </div>
    );
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e2e8f0',
          borderTopColor: '#8b5cf6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }}></div>
        <p style={{marginTop: '16px', color: '#64748b', fontWeight: '500'}}>Chargement...</p>
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>← Retour</button>
        <h1 style={styles.headerTitle}>Avis conformité</h1>
        <button style={styles.saveBtn} onClick={handleSave} disabled={saving}>
          {saving ? '⏳' : '💾'}
        </button>
      </div>

      {/* Badge RVRAT */}
      <div style={styles.badge}>
        🏛️ Rapport RVRAT - ERP 1er groupe<br/>
        <span style={{fontSize: '12px', fontWeight: '400'}}>Référentiel GN 10</span>
      </div>

      {/* Légende */}
      <div style={styles.legend}>
        <div style={styles.legendTitle}>📋 Légende des avis</div>
        <div style={styles.legendItems}>
          {STATUS_OPTIONS.map(opt => (
            <span 
              key={opt.value}
              style={{
                ...styles.legendItem,
                background: opt.bgColor,
                color: opt.color
              }}
            >
              {opt.label} = {opt.value === 'C' ? 'Conforme' : 
                           opt.value === 'NC' ? 'Non Conforme' : 
                           opt.value === 'SO' ? 'Sans Objet' : 
                           opt.value === 'HM' ? 'Hors Mission' : 'Pour Mémoire'}
            </span>
          ))}
        </div>
      </div>

      {/* Tabs */}
      <div style={styles.tabs}>
        <button 
          style={{...styles.tab, ...(activeTab === 'installations' ? styles.tabActive : {})}}
          onClick={() => setActiveTab('installations')}
        >
          ⚡ Installations EL
        </button>
        <button 
          style={{...styles.tab, ...(activeTab === 'eclairage' ? styles.tabActive : {})}}
          onClick={() => setActiveTab('eclairage')}
        >
          💡 Éclairage EC
        </button>
      </div>

      {/* Contenu */}
      <div style={styles.content}>
        {activeTab === 'installations' && (
          ARTICLES_INSTALLATIONS.map(article => renderArticle(article, 'installations_electriques'))
        )}
        {activeTab === 'eclairage' && (
          ARTICLES_ECLAIRAGE.map(article => renderArticle(article, 'eclairage'))
        )}
      </div>

      {/* Bouton sauvegarder */}
      <div style={styles.saveSection}>
        <button 
          style={{...styles.saveButton, ...(saving ? {opacity: 0.6, cursor: 'not-allowed'} : {})}} 
          onClick={handleSave} 
          disabled={saving}
        >
          {saving ? '⏳ Sauvegarde...' : '💾 Sauvegarder'}
        </button>
      </div>
    </div>
  );
}

export default Etape20AvisConformiteRVRATMobile;